import { notification } from "antd";
import dayjs from "dayjs";
import Helper from "../../Helper";
import { RecipientList } from "../../models/RecipientList";
import { plotFetch } from "../Helper/ApiRequest";

export const getRecipientLists = (subdomain: string, projectToken: string): Promise<RecipientList[]> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/recipient_lists`;

    return plotFetch(url)
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return response.map((list: any) => RecipientList.fromApiObject(list, timezone));
        })
        .catch(() => {
            notification.error({
                message: "Failed to get recipient lists",
                description: "Please try again later",
            });
        });
};

export const createRecipientList = (
    subdomain: string,
    projectToken: string,
    recipientList: RecipientList
): Promise<RecipientList | null> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/recipient_lists`;

    return plotFetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(recipientList.toApiObject()),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return RecipientList.fromApiObject(response, timezone);
        })
        .catch(() => {
            notification.error({
                message: "Failed to create recipient list",
                description: "Please try again later",
            });
            return null;
        });
};

export const updateRecipientList = (
    subdomain: string,
    projectToken: string,
    recipientList: RecipientList
): Promise<RecipientList | null> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/recipient_lists/${recipientList.id}`;

    return plotFetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(recipientList.toApiObject()),
    })
        .then((response) => {
            if (response.ok) {
                return response.json();
            } else {
                throw new Error("Network error.");
            }
        })
        .then((response) => {
            const timezone = dayjs.tz.guess();
            return RecipientList.fromApiObject(response, timezone);
        })
        .catch((error) => {
            notification.error({
                message: "Failed to update recipient list",
                description: `Please try again later${error.message ? ` Error: ${error.message}` : ""}`,
            });
            return null;
        });
};

export const deleteRecipientList = (
    subdomain: string,
    projectToken: string,
    recipientListId: number
): Promise<boolean> => {
    const url = `${Helper.baseUrlAltSubdomain(
        subdomain ? subdomain : "projects"
    )}/projects/${projectToken}/recipient_lists/${recipientListId}`;

    return plotFetch(url, {
        method: "DELETE",
    })
        .then((response) => {
            if (response.ok) {
                return true;
            } else {
                throw new Error("Network error.");
            }
        })
        .catch(() => {
            notification.error({
                message: "Failed to delete recipient list",
                description: "Please try again later",
            });
            return false;
        });
};
